export const applicationsGenerate = [
	{
		icon: '👠',
		title: 'applicationsData_title1',
		subtitle: 'applicationsData_subtitle1',
	},
	{
		icon: '🌈',
		title: 'applicationsData_title2',
		subtitle: 'applicationsData_subtitle2',
	},
	{
		icon: '🏠',
		title: 'applicationsData_title3',
		subtitle: 'applicationsData_subtitle3',
	},
	{
		icon: '🖼',
		title: 'applicationsData_title4',
		subtitle: 'applicationsData_subtitle4',
	},
	{
		icon: '📢',
		title: 'applicationsData_title5',
		subtitle: 'applicationsData_subtitle5',
	},
];
